import { useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { useQueryClient } from '@tanstack/react-query';
import { authClient } from '../../lib/api';
import { Button } from '../ui/button';
import { Dialog } from '../ui/dialog';
import { Mascot } from '../ui/mascot';

/** Figma "Log out?" sheet (386:29597): Stay / Log out. Log out is the design's red button. */
export function LogoutDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [busy, setBusy] = useState(false);

  const logOut = async () => {
    setBusy(true);
    await authClient.signOut();
    // Drop every cached query: nothing from this account should survive into the next sign-in.
    queryClient.clear();
    await navigate({ to: '/subdomain/app/sign-in' });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Log out?"
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={busy} className="flex-1">
            Stay
          </Button>
          <Button variant="destructive" onClick={() => void logOut()} loading={busy} className="flex-1">
            Log out
          </Button>
        </>
      }
    >
      <div className="flex flex-col items-center gap-(--mbm-space-3) text-center">
        <Mascot pose="think" className="h-(--mbm-size-mascot-height) w-(--mbm-size-mascot-width)" />
        <p className="text-body-medium text-text-secondary">
          You’ll stop getting notifications on this device until you sign in again.
        </p>
      </div>
    </Dialog>
  );
}
